import React, { useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import ClassContainer from '../ClassContainer';
import { StyledFieldset, StyledControlledInput, StyledInputContainer } from './index.styles';

const Details: React.FC = () => {
    const { t } = useTranslation('create_edit_class');
    const { control, handleClassNameFocus } = useContainer(ClassContainer);
    const passcodeInputRef = useRef<HTMLInputElement>(null);

    const onPasscodeClick = () => {
        if (passcodeInputRef) {
            // this solution also works on safari/mac client
            passcodeInputRef.current?.select();
        }
    };

    return (
        <StyledFieldset>
            <StyledInputContainer>
                <StyledControlledInput onFocus={handleClassNameFocus} placeholder={t('details.enter-class-name')} label={t('details.class-name')} name="className" control={control} />
            </StyledInputContainer>
            <StyledInputContainer>
                <StyledControlledInput placeholder={t('details.enter-class-id')} label={t('details.class-id')} name="classId" control={control} helperText={t('optional')} />
            </StyledInputContainer>
            <StyledInputContainer>
                <StyledControlledInput placeholder={t('details.enter-description')} label={t('details.description')} name="description" control={control} helperText={t('optional')} />
            </StyledInputContainer>
            <StyledInputContainer>
                <StyledControlledInput inputProps={{ maxLength: 10 }} inputRef={passcodeInputRef} onClick={onPasscodeClick} placeholder={t('details.enter-class-passcode')} label={t('details.class-passcode')} name="classPasscode" control={control} />
            </StyledInputContainer>
        </StyledFieldset>
    );
};

export default Details;
